import { render, staticRenderFns } from "./AlertComponent.vue?vue&type=template&id=6595e872&"
import script from "./AlertComponent.vue?vue&type=script&lang=js&"
export * from "./AlertComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports